import {QualificationsProfessionnelles} from './QualificationsProfessionnelles';
import {AutorisationSpecifique} from './AutorisationSpecifique';
import {ConformiteFournitures} from './ConformiteFournitures';
export class TypeJustif {

	public detailFournitures: string;

	public autorisationSpecifique: AutorisationSpecifique;

	public redressementJudiciaire: string;

	public certificatPaysOrigine: string;

	public articlesD8222: string;

	public indicationTitresOperateur: string;

	public qualificationsProfessionnelles: QualificationsProfessionnelles;

	public documentsAutreOperateur: string;

	public traductionFrancaiseAttributaire: string;

	public justificationAutre: string[];

	public listeTravaux: string;

	public defenseNationaliteCandidat: string;

	public chiffresAffaires: string;

	public articleL3243: string;

	public articlesL1221L3243: string;

	public article2141: string;

	public equipementFournituresServices: string;

	public listeFournituresServices: string;

	public indicationTitresCadres: string;

	public justificationComment: string;

	public defenseHabilitationSecret: string;

	public dc2: string;

	public effectifs: string;

	public dc1: string;

	public bilans: string;

	public dc4: string;

	public conformiteFournitures: ConformiteFournitures;

	public dc3: string;

	public equipementTechnique: string;

	public attestationObligationsFiscales: string;

	public risquesProfessionels: string;

	public articlesL5212: string;

	public traductionFrancaiseCandidat: string;

	public docsConsultation: string;

	constructor() { 
		 		this.detailFournitures = '';
		this.autorisationSpecifique = null;
		this.redressementJudiciaire = '';
		this.certificatPaysOrigine = '';
		this.articlesD8222 = '';
		this.indicationTitresOperateur = '';
		this.qualificationsProfessionnelles = null;
		this.documentsAutreOperateur = '';
		this.traductionFrancaiseAttributaire = '';
		this.justificationAutre = [];
		this.listeTravaux = '';
		this.defenseNationaliteCandidat = '';
		this.chiffresAffaires = '';
		this.articleL3243 = '';
		this.articlesL1221L3243 = '';
		this.article2141 = '';
		this.equipementFournituresServices = '';
		this.listeFournituresServices = '';
		this.indicationTitresCadres = '';
		this.justificationComment = '';
		this.defenseHabilitationSecret = '';
		this.dc2 = '';
		this.effectifs = '';
		this.dc1 = '';
		this.bilans = '';
		this.dc4 = '';
		this.conformiteFournitures = null;
		this.dc3 = '';
		this.equipementTechnique = '';
		this.attestationObligationsFiscales = '';
		this.risquesProfessionels = '';
		this.articlesL5212 = '';
		this.traductionFrancaiseCandidat = '';
		this.docsConsultation = '';
 
	}
}
